export const bindInputProps = ({
  name,
  values,
  handleChange,
  setFieldTouched,
  touched,
  errors,
}) => {
  return {
    value: values[name] || "",
    onChange: handleChange(name),
    onBlur: () => setFieldTouched(name),
    touched: touched[name],
    errors: errors[name],
    name,
  };
};

export const bindArrayInputProps = ({
  parent,
  index,
  name,
  values,
  handleChange,
  setFieldTouched,
  touched,
  errors,
}) => {
  const childName = `${parent}.${index}.${name}`;
  return {
    value: values[parent][index][name] || "",
    onChange: handleChange(childName),
    onBlur: () => setFieldTouched(childName),
    touched: touched[childName],
    errors: errors[childName],
    name: childName,
  };
};

export const mapingFormFields = {
  LIST: (field, onChange) => {
    const items = (field.formFieldListItems || []).map((opt) => ({
      value: opt.code,
      label: opt.desc,
    }));

    return {
      items,
      mode: "select",
      placeholder: field.desc,
      onChange,
    };
  },
  TEXT: (field, onChange) => ({
    mode: "simple",
    placeholder: field.desc,
    onChange: (e) => onChange(e.target.value),
  }),
  CHECKBOX: (field, onChange) => ({
    mode: "checkbox",
    label: field.desc,
    onChange: (e) => onChange(e.target.value),
  }),
  DATE: (field, onChange) => ({
    mode: "date",
    label: field.desc,
    onChange: (e) => onChange(e.target.value),
  }),
  TIME: (field, onChange) => ({
    mode: "time",
    label: field.desc,
    onChange: (e) => onChange(e.target.value),
  }),
  DATETIME: (field, onChange) => ({
    mode: "dateTime",
    label: field.desc,
    onChange: (e) => onChange(e.target.value),
  }),
};
